/**
 * Centralised Firestore path builders.
 *
 * All collections are namespaced under /users/{uid} so that the security
 * rule  `request.auth.uid == userId`  fully isolates per-user data.
 */
export const paths = {
  user: (uid: string) => `users/${uid}`,

  projects: (uid: string) => `users/${uid}/projects`,
  project: (uid: string, projectId: string) =>
    `users/${uid}/projects/${projectId}`,

  sprints: (uid: string, projectId: string) =>
    `users/${uid}/projects/${projectId}/sprints`,
  sprint: (uid: string, projectId: string, sprintId: string) =>
    `users/${uid}/projects/${projectId}/sprints/${sprintId}`,

  tasks: (uid: string, projectId: string, sprintId: string) =>
    `users/${uid}/projects/${projectId}/sprints/${sprintId}/tasks`,
  task: (uid: string, projectId: string, sprintId: string, taskId: string) =>
    `users/${uid}/projects/${projectId}/sprints/${sprintId}/tasks/${taskId}`,

  assignees: (uid: string, projectId: string) =>
    `users/${uid}/projects/${projectId}/assignees`,
  assignee: (uid: string, projectId: string, id: string) =>
    `users/${uid}/projects/${projectId}/assignees/${id}`,

  statusAliases: (uid: string, projectId: string) =>
    `users/${uid}/projects/${projectId}/statusAliases`,
  statusAlias: (uid: string, projectId: string, id: string) =>
    `users/${uid}/projects/${projectId}/statusAliases/${id}`,

  dailyGoals: (uid: string, projectId: string, sprintId: string) =>
    `users/${uid}/projects/${projectId}/sprints/${sprintId}/dailyGoals`,
  callTopics: (uid: string, projectId: string, sprintId: string) =>
    `users/${uid}/projects/${projectId}/sprints/${sprintId}/callTopics`,
  refinements: (uid: string, projectId: string, sprintId: string) =>
    `users/${uid}/projects/${projectId}/sprints/${sprintId}/refinements`,
  scopeItems: (uid: string, projectId: string, sprintId: string) =>
    `users/${uid}/projects/${projectId}/sprints/${sprintId}/scope`,
};
